import cn from 'classnames'
import Image from 'next/image'
import React from 'react'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { IAbout } from 'src/graphql/generated/hooks'

import what from '../../assets/ic-what.png'
import who from '../../assets/ic-who.png'

interface AboutHeaderProps {
  className?: string
  about: IAbout
}

/**
 * Primary UI component for user interaction
 */
export const AboutHeader: React.FC<AboutHeaderProps> = ({ className, about }) => {
  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full py-2">
        <div className="flex flex-row sm:grid-cols-2">
          <div className="self-center">
            <div className="flex flex-row md:mb-[0rem] mb-[0.875rem]">
              <div className="flex flex-col md:w-1/2 w-full">
                <div className="flex flex-col">
                  <h1 className="pt-[0.1rem] pb-[0.125rem] text-[1.5rem] font-bold font-secondary text-[#222222]">
                    About Legaltech Hub
                  </h1>
                </div>
              </div>
            </div>

            <HtmlContentViewer
              className="md:text-[1.125rem] text-[0.9375rem] font-primary font-regular text-darkgray"
              html={about?.description || ''}
            />
          </div>
        </div>
        <div className="flex md:flex-row flex-col w-full md:mt-[4.25rem] md:mb-[4.25rem] mt-[1.25rem] mb-[1.25rem]">
          <div className="flex flex-col md:w-1/2 w-full">
            <div>
              <Image className="" src={who} alt="" width={80} height={80} />
            </div>
            <h2 className="pt-[0.1rem] pb-[0.125rem] text-[1.5rem] font-bold font-secondary text-[#222222] md:mb-[0rem] mb-[0.875rem]">
              Who We Are
            </h2>
            <h3>
              <HtmlContentViewer
                className="md:text-[1.125rem] text-[0.9375rem] font-primary font-regular text-darkgray"
                html={about?.who || ''}
              />
            </h3>
          </div>
          <div className="flex flex-col md:w-1/2 w-full md:mt-[0rem] mt-[24px]">
            <div>
              <Image className="" src={what} alt="" width={80} height={80} />
            </div>
            <h2 className="pt-[0.1rem] pb-[0.125rem] md:text-[1.5rem] text-[20px] font-bold font-secondary text-[#222222] md:mb-[0rem] mb-[0.875rem] pr-[1.25rem]">
              What We Do
            </h2>
            <h3>
              <HtmlContentViewer
                className="md:text-[1.125rem] text-[0.9375rem] font-primary font-regular text-darkgray"
                html={about?.what || ''}
              />
            </h3>
          </div>
        </div>
      </div>
    </div>
  )
}
